var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('span',{domProps:{"textContent":_vm._s(_vm.title)}}),_c('em',{style:({ background: _vm.color }),domProps:{"textContent":_vm._s(_vm.tag)}})]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"card-number"},[_c('span',{domProps:{"textContent":_vm._s(_vm.number)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }